export class Mapping {
	public columnNumber : number;
	public fieldName: string; 


	constructor(o?:any) {
		Object.assign(this, o);
	}
}